import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  Typography,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import AudienceDesignator from './AudienceDesignator';
import { AudienceApi } from '@/api/clients/audience/audience.api';
export default function AudienceConfiguration({
  formValues,
  isUpdating,
  onAudienceDesignatorChange,
  removeAudienceDesignator,
  addAudienceDesignator,
  isSingleAudience,
  selectedAudienceId,
  onIsSingleAudienceChange,
  onSelectedAudienceChange,
}) {
  const { t } = useTranslation();
  const [audiences, setAudiences] = useState([]);

  useEffect(() => {
    fetchAudiences();
  }, []);

  const fetchAudiences = async () => {
    try {
      const response = await AudienceApi.getAudiencesForForm(false);

      setAudiences(response.data || []);
    } catch (error) {
      console.error('Error fetching audiences:', error);
      setAudiences([]);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div
            style={{
              border: '1px dashed #ccc',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '16px',
              marginTop: '10px',
              backgroundColor: !isUpdating('data-mapping')
                ? '#f5f5f5'
                : 'transparent',
            }}>
            <FormControl component='fieldset'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isSingleAudience}
                    onChange={onIsSingleAudienceChange}
                    name='isSingleAudience'
                    disabled={!isUpdating('data-mapping')}
                  />
                }
                label={
                  <>
                    <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                      {t(
                        'dataMappings.audienceConfiguration.singleAudience.title',
                      )}
                    </Typography>
                    <Typography variant='body2' style={{ color: '#666' }}>
                      {t(
                        'dataMappings.audienceConfiguration.singleAudience.description',
                      )}
                    </Typography>
                  </>
                }
              />
            </FormControl>
          </div>
        </GridItem>

        <GridItem xs={12} sm={12} md={6}>
          <div
            style={{
              border: '1px dashed #ccc',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '16px',
              marginTop: '10px',
              backgroundColor: !isUpdating('data-mapping')
                ? '#f5f5f5'
                : 'transparent',
            }}>
            <FormControl component='fieldset'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!isSingleAudience}
                    onChange={(e) =>
                      onIsSingleAudienceChange({
                        target: { checked: !e.target.checked },
                      })
                    }
                    name='useAudienceDesignator'
                    disabled={!isUpdating('data-mapping')}
                  />
                }
                label={
                  <>
                    <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                      {t(
                        'dataMappings.audienceConfiguration.audienceDesignator.title',
                      )}
                    </Typography>
                    <Typography variant='body2' style={{ color: '#666' }}>
                      {t(
                        'dataMappings.audienceConfiguration.audienceDesignator.description',
                      )}
                    </Typography>
                  </>
                }
              />
            </FormControl>
          </div>
        </GridItem>
      </GridContainer>

      {isSingleAudience && (
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl fullWidth style={{ marginBottom: '16px' }}>
              <InputLabel>
                {t('dataMappings.audienceConfiguration.selectAudience.label')}
              </InputLabel>
              <Select
                value={selectedAudienceId || ''}
                onChange={onSelectedAudienceChange}
                label={t(
                  'dataMappings.audienceConfiguration.selectAudience.label',
                )}
                disabled={!isUpdating('data-mapping')}>
                <MenuItem value=''>
                  <em>
                    {t(
                      'dataMappings.audienceConfiguration.selectAudience.placeholder',
                    )}
                  </em>
                </MenuItem>
                {audiences.map((audience) => (
                  <MenuItem key={audience.id} value={audience.id}>
                    {audience.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
      )}

      {!isSingleAudience && (
        <AudienceDesignator
          formValues={formValues}
          isUpdating={isUpdating}
          onAudienceDesignatorChange={onAudienceDesignatorChange}
          removeAudienceDesignator={removeAudienceDesignator}
          addAudienceDesignator={addAudienceDesignator}
        />
      )}
    </>
  );
}
